import React from "react";
import "./NewsCard.css";

const NewsCard = ({ post, onClick }) => {
  return (
    <div className="news-card" onClick={onClick}>
      <img
        src={post.picture}
        alt={post.title}
        className="news-image"
      />
      <div className="news-content">
        <p className="date">{post.date}</p>
        <p className="news-text-card">{post.text}</p>
      </div>
      <a href={post.link} target="_blank" rel="noopener noreferrer" className="fb-show">
          Zobacz na Facebooku
        </a>
    </div>
  );
};

export default NewsCard;
